var map = {
	"./3dcapsule.png": 7364,
	"./3dtriangle.png": 8078,
	"./3dtube.png": 8027,
	"./Arrow Right.svg": 3195,
	"./Design.svg": 7336,
	"./Develope.svg": 5779,
	"./Support.svg": 6715,
	"./arrow-up.svg": 8770,
	"./avatar-1.jpg": 8310,
	"./avatar-2.jpg": 3128,
	"./avatar-3.jpg": 2873,
	"./avatar-4.jpg": 4270,
	"./blob purple.png": 760,
	"./blob white.png": 9698,
	"./blobPink.png": 4,
	"./envelope-open-solid.svg": 8860,
	"./facebook-square-brands.svg": 2799,
	"./hand.svg": 8377,
	"./human.svg": 2779,
	"./instagram-square-brands.svg": 9990,
	"./linkedin-brands.svg": 3960,
	"./log.svg": 4108,
	"./logo.svg": 9574,
	"./mobile.svg": 4183,
	"./register.svg": 5947,
	"./rocket image.png": 1711,
	"./twitter-square-brands.svg": 5565,
	"./waves.svg": 4972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;